import { z } from 'zod';

export const SettingsSchema = z.object({
  store_name: z.string().min(1, 'Store name is required'),
  store_address: z.string().min(1, 'Store address is required'),
  store_phone_number: z.string().min(1, 'Store phone number is required'),
  footer_thank_you_message: z.string().optional(),
  footer_terms_and_conditions: z.string().optional(),
  logo: z.string().optional(),
  logo_type: z.string().optional(),
});

export const SettingsStoreResponseSchema = z.object({
  data: SettingsSchema,
  message: z.string(),
  statusCode: z.number(),
});

export type SettingsSchemaType = z.infer<typeof SettingsSchema>;
export type SettingsStoreResponseSchemaType = z.infer<
  typeof SettingsStoreResponseSchema
>;
